/**
 * Brand Configuration — Single source of truth for theming.
 * Fork this file to create sister brands (Mind Games, Smiley Gift, etc.)
 */

export interface BrandConfig {
  name: string;
  tagline: string;
  description: string;
  domain: string;
  locale: string;
  direction: "rtl" | "ltr";
  fontFamily: string;
  fontUrl: string;
  colors: {
    primary: string;
    primaryForeground: string;
    accent: string;
    accentForeground: string;
    background: string;
    foreground: string;
    card: string;
    badge: string;
    badgeForeground: string;
    success: string;
    successForeground: string;
    hot: string;
    hotForeground: string;
    muted: string;
    mutedForeground: string;
    border: string;
    ring: string;
  };
  gradientPrimary: string;
  gradientAccent: string;
  ogImage: string;
  favicon: string;
}

export const brand: BrandConfig = {
  name: "NiceGift",
  tagline: "מתנות מותאמות אישית",
  description: "זירת מסחר ישראלית למתנות ומוצרים מותאמים אישית",
  domain: "www.nicegift.co.il",
  locale: "he_IL",
  direction: "rtl",
  fontFamily: "'Assistant', sans-serif",
  fontUrl: "/fonts/assistant-hebrew.woff2", // self-hosted, no external dependency
  colors: {
    primary: "145 65% 42%",
    primaryForeground: "0 0% 100%",
    accent: "175 55% 42%",
    accentForeground: "0 0% 100%",
    background: "220 25% 7%",
    foreground: "0 0% 98%",
    card: "220 22% 11%",
    badge: "205 75% 50%",
    badgeForeground: "0 0% 100%",
    success: "145 65% 45%",
    successForeground: "0 0% 100%",
    hot: "340 75% 55%",
    hotForeground: "0 0% 100%",
    muted: "220 16% 18%",
    mutedForeground: "0 0% 75%",
    border: "220 16% 22%",
    ring: "145 65% 42%",
  },
  gradientPrimary: "linear-gradient(135deg, hsl(145 65% 42%), hsl(175 55% 42%))",
  gradientAccent: "linear-gradient(135deg, hsl(175 55% 42%), hsl(205 75% 50%))",
  ogImage: "https://www.nicegift.co.il/og-image.png",
  favicon: "/favicon.ico",
};

/*
 * ─── Sister Brand Examples ───
 *
 * export const mindGames: BrandConfig = {
 *   ...brand,
 *   name: "Mind Games",
 *   tagline: "משחקי חשיבה ולוגיקה",
 *   description: "החנות המובילה למשחקי חשיבה ופאזלים בישראל",
 *   domain: "mindgames.co.il",
 *   colors: {
 *     ...brand.colors,
 *     primary: "260 70% 55%",       // Purple
 *     accent: "180 70% 45%",        // Teal
 *     ring: "260 70% 55%",
 *   },
 *   gradientPrimary: "linear-gradient(135deg, hsl(260 70% 55%), hsl(280 70% 45%))",
 * };
 *
 * export const smileyGift: BrandConfig = {
 *   ...brand,
 *   name: "Smiley Gift",
 *   tagline: "מתנות שמחות",
 *   description: "מתנות יצירתיות ומקוריות שמביאות חיוך",
 *   domain: "smileygift.co.il",
 *   colors: {
 *     ...brand.colors,
 *     primary: "45 95% 50%",        // Golden yellow
 *     accent: "330 80% 55%",        // Pink
 *     ring: "45 95% 50%",
 *   },
 *   gradientPrimary: "linear-gradient(135deg, hsl(45 95% 50%), hsl(35 95% 45%))",
 * };
 */
